const CONTENT_TYPE_NAMES: Record<string, string> = {
	favouritefeed: "Favourite Feed",
	homepagequicklink: "Quick Links",
	homepagekeyshout: "Key Shouts",
	homepagepromotion: "Promotions",
	promotionalitem: "Promotions"
};

export function getContentTypeName(contentType: string): string {
	return CONTENT_TYPE_NAMES[contentType] ?? contentType;
}
